import { render, staticRenderFns } from "./OverridableButtonInput.vue?vue&type=template&id=def252e4&scoped=true&"
import script from "./OverridableButtonInput.vue?vue&type=script&lang=js&"
export * from "./OverridableButtonInput.vue?vue&type=script&lang=js&"
import style0 from "./OverridableButtonInput.vue?vue&type=style&index=0&id=def252e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def252e4",
  null
  
)

export default component.exports